// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2jrwT","label":"LabeledBox_label__3-92Q"};